"use strict";
/*
 * Created on 10. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Settings specific for client of pricing application:
 * Mapping of: release type - price list type - price code - price list priority - rule - priority of rule application
 * This mapping represents table from Blueprint: Table 19 Price list with price codes, rules and priorities,
 * newer version is available here: https://drive.google.com/file/d/1lkFEQ8Cvv_LdoEm2KWQfKTyG0hqapmI8/view?ts=5c0a66dc
 *
 * @author Radek Beran
 */


var PriceListSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceListSettings, _DomainObject_1$Domai);

  // FIXME The entire collection could be loaded to memory during application startup. At least cache results.

  /**
   * Constructs price list settings.
   * @param id
   * @param releaseType type of release; or null for ad-hoc price list type not bound to any release type
   * @param priceListType type of price list, e.g. EDLP, Promo, Regular, ...
   * @param priceListTypeId
   * @param priceCodes available price codes settings
   * @param priority priority of corresponding price list
   * @param tags list of internal tags which can be used to lookup settings which relates to some situation
   * @param selloutReleaseType corresponding type of sellout release (if any)
   */
  function PriceListSettings(id, releaseType, priceListType, priceListTypeId, priceCodes, priority, tags, selloutReleaseType) {
    var _this;

    _classCallCheck(this, PriceListSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceListSettings).call(this));
    _this.id = id;
    _this.releaseType = releaseType;
    _this.priceListType = priceListType;
    _this.priceListTypeId = priceListTypeId;
    _this.priceCodes = priceCodes;
    _this.priority = priority;
    _this.tags = tags;
    _this.selloutReleaseType = selloutReleaseType;
    return _this;
  }
  /**
   * Returns true if this is settings for EDLP price list.
   */


  _createClass(PriceListSettings, [{
    key: "isEDLP",
    value: function isEDLP() {
      return this.tags.map(function (tag) {
        return tag.toLowerCase();
      }).toSet().contains('edlp');
    }
  }]);

  return PriceListSettings;
}(DomainObject_1.DomainObject);

exports.PriceListSettings = PriceListSettings;